<script setup lang="ts">
import { TooltipArrow, TooltipContent, TooltipPortal, TooltipRoot, TooltipTrigger } from "reka-ui"

interface TooltipProps {
  content?: string
  side?: "top" | "bottom" | "left" | "right"
  triggerClass?: string
}

withDefaults(defineProps<TooltipProps>(), {
  content: "",
  side: "top",
  triggerClass: "",
})
</script>

<template>
  <TooltipRoot>
    <TooltipTrigger as-child>
      <span :class="triggerClass">
        <slot />
      </span>
    </TooltipTrigger>
    <TooltipPortal v-if="content">
      <TooltipContent
        class="max-w-sm select-none break-words whitespace-normal rounded-md border bg-white px-[15px] py-[10px] text-sm leading-snug shadow-sm will-change-[transform,opacity]"
        :side-offset="2"
        :side="side"
      >
        <slot name="content">
          {{ content }}
        </slot>
        <TooltipArrow
          class="fill-white stroke-gray-200"
          :width="12"
          :height="6"
        />
      </TooltipContent>
    </TooltipPortal>
  </TooltipRoot>
</template>
